import {constants} from './constants'
import axios from "axios";

export const services = {
    getBrands,
    getProducts,
    getServiceSyms,
    getProvinces,
    getCities,
    getRegions,
    getParishes,
    submitRequest
};

async function getBrands() {
    return await axios.post(constants.host + 'api/Brands', {
        "username": constants.userName,
        "password": constants.password,
        "connectionname": constants.connectionName
    })
}

async function getProducts(brandId) {
    return await axios.post(constants.host + 'api/products', {
        "brandId": brandId,
        "username": constants.userName,
        "password": constants.password,
        "connectionname": constants.connectionName
    })
}

async function getServiceSyms(productId) {
    return await axios.post(constants.host + 'api/ServiceSyms', {
        "productid": productId,
        "term": "",
        "username": constants.userName,
        "password": constants.password,
        "connectionname": constants.connectionName
    })
}

async function getProvinces() {
    return await axios.post(constants.host + 'api/Provinces', {
        "username": constants.userName,
        "password": constants.password,
        "connectionname": constants.connectionName
    })
}

async function getCities(provinceId) {
    return await axios.post(constants.host + 'api/Cities', {
        "provinceId": provinceId,
        "username": constants.userName,
        "password": constants.password,
        "connectionname": constants.connectionName
    })
}

async function getRegions(cityId) {
    return await axios.post(constants.host + 'api/Regions', {
        "cityId": cityId,
        "username": constants.userName,
        "password": constants.password,
        "connectionname": constants.connectionName
    })
}

async function getParishes(cityId, regionId) {
    return await axios.post(constants.host + 'api/Parishes', {
        "cityId": cityId,
        "regionId": regionId,
        "term": "",
        "username": constants.userName,
        "password": constants.password,
        "connectionname": constants.connectionName
    })
}

async function submitRequest(type, firstName, lastName, mobile, homeTel, identificationMobile,
                             serviceTypeId, brandId, productTypeId, serviceSymId, descriptions,
                             cityId, regionId, parishId, addressDesc) {
    return await axios.post(constants.host + 'api/SubmitRequest', {
        "type": type,
        "firstName": firstName,
        "lastName": lastName,
        "mobile": mobile,
        "homeTel": homeTel,
        // "identificationMobile": identificationMobile !== "" ? identificationMobile : "09917277761",
        "identificationMobile": "09127840901",
        // "identificationMobile": identificationMobile,
        "serviceTypeId": serviceTypeId,
        "brandId": brandId,
        "productTypeId": productTypeId,
        "serviceSymId": serviceSymId,
        "descriptions": descriptions,
        "cityId": cityId,
        "regionId": regionId,
        "parishId": parishId,
        "addressDesc": addressDesc,
        "username": constants.userName,
        "password": constants.password,
        "cnName": constants.connectionName
    })
}